import React from 'react';
import { Box, Text } from '@chakra-ui/react';

function ChatView({ data }) {
    const styles = {
        background: {
            Inbound: '#dadada',
            Outbound: 'green.500'
        },
        font: {
            Inbound: 'black',
            Outbound: 'white'
        },
        leftMargin: {
            Inbound: '0',
            Outbound: '20%'
        },
        rightMargin: {
            Inbound: '20%',
            Outbound: '0'
        },
    }

    return (
        <Box>
            {data?.transcript?.map((message, itx) => {
                return (
                    <Box
                        key={`${itx}-box`}
                        p="10px"
                        mt="20px"
                        borderRadius="10px"
                        width="80%"
                        bg={styles.background[message.Direction]}
                        color={styles.font[message.Direction]}
                        ml={styles.leftMargin[message.Direction]}
                        mr={styles.rightMargin[message.Direction]}
                    >
                        <Text><b>Member: </b>{message.Member}</Text>
                        <Text><b>Direction: </b>{message.Direction}</Text>
                        <Text><b>Message: </b>{message.Message}</Text>
                    </Box>
                )
            })}
        </Box>
    );
}

export default ChatView;
